import React from 'react';
import { Tooltip, Link } from '@material-ui/core';
import FontAwesome from 'Components/UI/FontAwesome/FontAwesome';
import PropTypes from 'prop-types';
import { toggleModal } from 'Helpers/ModalHelper';
import modalNames from 'Consts/ModalNames';
import moment from 'moment';
import { getTimestampFromString } from 'Helpers/DateTime';
import useUserContext from 'Context/UserContext';
import { useBalanceSheetPageURL } from 'Hooks/useBalanceSheetPageURL';


export default function AccountLinked({
  lastSync,
  failed,
  showLastSyncLabel,
  ...rest
}) {
  const { isAgent } = useUserContext();
  const balanceSheetPageURL = useBalanceSheetPageURL();

  const LinkIcon = (!isAgent)
    ? (
      <Link href={balanceSheetPageURL}>
        <FontAwesome
          icon={failed ? 'exclamation-circle' : 'link'}
          style={{ cursor: 'pointer' }}
        />
      </Link>
    )
    : (
      <FontAwesome
        icon={failed ? 'exclamation-circle' : 'link'}
        style={{ cursor: 'pointer' }}
        onClick={(e) => {
          e.stopPropagation();
          toggleModal(modalNames.accountAggregator);
        }}
      />
    );
  const getTitle = () => {
    const updatedAtMoment = moment(getTimestampFromString(lastSync));
    const displayTime = updatedAtMoment.format('M/DD/YY HH:MM:SS');

    if (failed) {
      return (
        <>
          <p> Something wrong with your account. Click for more information </p>
          <p>{lastSync ? `Last synced on ${displayTime}` : null}</p>
        </>
      );
    }
    return lastSync
      ? `Last synced on ${displayTime}`
      : 'Your account is linked';
  };

  const getLabelLastSync = () => {
    if (!showLastSyncLabel) {
      return '';
    }

    if (!failed && lastSync) {
      const updatedAtMoment = moment(getTimestampFromString(lastSync));
      return ` Last synced on ${updatedAtMoment.format('M/DD/YY')}`;
    }

    return '';
  };

  return (
    <span {...rest}>
      <Tooltip
        title={getTitle()}
        placement="bottom"
        overlayClassName="account-signin-error"
        visible
      >
        {LinkIcon}
      </Tooltip>
      {getLabelLastSync()}
    </span>
  );
}

AccountLinked.propTypes = {
  lastSync: PropTypes.string.isRequired,
  failed: PropTypes.bool,
  showLastSyncLabel: PropTypes.bool,
};

AccountLinked.defaultProps = {
  failed: false,
  showLastSyncLabel: false,
};
